module.exports = __webpack_public_path__ + "static/media/login.b4d7c07e.jpg";